import {
  CalendarType,
  prisma,
  Prisma,
  CalendarIntegrationMeeting,
} from "client";

export const createIntegrationCalendarIfNotExists = async (
  data: Prisma.CalendarIntegrationUncheckedCreateInput
) => {
  const calendar = await prisma.calendarIntegration.findFirst({
    where: { userId: data.userId, calendarType: data.calendarType },
  });
  if (calendar) {
    await prisma.calendarIntegration.update({
      where: { id: calendar.id },
      data,
    });
    return calendar;
  }
  const newCalendar = await prisma.calendarIntegration.create({
    data,
  });
  return newCalendar;
};

export const deleteIntegrationCalendar = async (
  userId: string,
  calendarType: CalendarType
) => {
  // await prisma.calendarIntegrationMeeting.updateMany({
  //   where: { calendarIntegration: { userId, calendarType } },
  //   data: { deletedAt: new Date() },
  // });
  const calendar = await prisma.calendarIntegration.updateMany({
    where: { userId, calendarType },
    data: { active: false },
  });
  return calendar;
};

export const getIntegrationCalendars = async (
  filters: Prisma.CalendarIntegrationWhereInput
) => {
  const calendar = await prisma.calendarIntegration.findMany({
    where: { ...filters },
    include: {
      CalendarIntegrationMeeting: true,
    },
  });
  return calendar;
};

export const getUserIntegrationCalendars = async (userId: string) => {
  const calendars = await prisma.calendarIntegration.findMany({
    where: { userId },
  });
  return calendars;
};

export const selectIntegrationCalendar = async (
  userId: string,
  calendarType: CalendarType
) => {
  // First, try to find existing record
  const existingCalendar = await prisma.calendarIntegration.findFirst({
    where: { userId, calendarType },
  });

  let activeCalendar;
  if (existingCalendar) {
    // Update existing record
    activeCalendar = await prisma.calendarIntegration.update({
      where: { id: existingCalendar.id },
      data: { active: true },
    });
  } else {
    // Create new record
    activeCalendar = await prisma.calendarIntegration.create({
      data: { userId, calendarType, active: true },
    });
  }

  // Deactivate other calendar types for this user
  await prisma.calendarIntegration.updateMany({
    where: { userId, calendarType: { not: calendarType } },
    data: { active: false },
  });

  return activeCalendar;
};

export const createCalendarIntegrationMeeting = async ({
  calendarId,
  calendarIntegrationId,
  meetingId,
}: {
  calendarIntegrationId: string;
  meetingId: string;
  calendarId: string;
}) => {
  const meeting = await prisma.calendarIntegrationMeeting.create({
    data: {
      calendarId,
      calendarIntegrationId,
      meetingId,
    },
  });
  return meeting;
};

export const removeCalendarIntegrationMeeting = async ({
  calendarIntegrationId,
  meetingId,
  userId,
}: {
  calendarIntegrationId: string;
  meetingId: string;
  userId: string;
}) => {
  const meeting = await prisma.calendarIntegrationMeeting.deleteMany({
    where: {
      calendarIntegrationId,
      meetingId,
      calendarIntegration: {
        userId: userId,
      },
    },
  });
  return meeting;
};
